<accredible-base-header *transloco="let t; lang: 'en|static' read: 'credentialsdirectory_uipath_com.header'">
  <div class="header-logo-container"
    identitySection>
    <img
      [alt]="t('issuer_logo')"
      class="branding-logo"
      src="/assets/themes/credentialsdirectory.uipath.com/images/header_logo.jpg">
  </div>

  <div navigationSection>
    <sl-header-menu *ngIf="user$ | async else signIn"
      [extraDynamicMenuItems]="extraHeaderLinks">
    </sl-header-menu>

    <ng-template #signIn>
      <div class="sign-in-wrapper">
        <a href="https://uipath.eu.auth0.com/samlp/bzNb0yboTmEVIUYx8FQUKCO783ZU4QJc">
          {{ t('sign_in') }}
        </a>
      </div>
    </ng-template>
  </div>
</accredible-base-header>
